export const dialogStates = {
  TRANSITION: 'TRANSITION',
  PRICE_CHANGE: 'PRICE_CHANGE',
  ERROR: 'ERROR',
} as const;

export type DialogStates = (typeof dialogStates)[keyof typeof dialogStates];
